// Incentive spirometry data for the Vyaire AirLife 2500 ml spirometer
import { range } from 'lodash';

const data = {
  // female
  Female: {
    // ages in years: 20 to 80 with step size 5
    ages: range(20, 81, 5),
    // heights in inches: 58 to 74 with step size 2
    heights: range(58, 75, 2),
    // spirometry values in ml
    spiro: [
      // 58,   60,   62,   64,   66,   68,   70,   72,   74 heights (in)
      [2250, 2400, 2550, 2750, 2900, 3050, 3200, 3350, 3500], // age 20
      [2200, 2350, 2500, 2650, 2800, 2950, 3100, 3250, 3400], // age 25
      [2100, 2250, 2400, 2600, 2750, 2900, 3050, 3200, 3350], // age 30
      [2050, 2200, 2350, 2500, 2650, 2800, 2950, 3100, 3250], // age 35
      [1950, 2100, 2250, 2450, 2600, 2750, 2900, 3050, 3200], // age 40
      [1900, 2050, 2200, 2350, 2500, 2650, 2800, 3000, 3100], // age 45
      [1800, 1950, 2100, 2300, 2450, 2600, 2750, 2900, 3050], // age 50
      [1750, 1900, 2050, 2200, 2350, 2500, 2650, 2800, 2950], // age 55
      [1650, 1820, 1950, 2150, 2300, 2450, 2600, 2750, 2900], // age 60
      [1600, 1750, 1900, 2050, 2200, 2350, 2500, 2650, 2800], // age 65
      [1500, 1650, 1800, 2000, 2150, 2300, 2450, 2600, 2750], // age 70
      [1450, 1600, 1750, 1950, 2050, 2200, 2350, 2500, 2650], // age 75
      [1350, 1500, 1650, 1850, 2000, 2150, 2300, 2450, 2600]  // age 80
    ]
  },

  // male
  Male: {
    // ages in years: 20 to 80 with step size 5
    ages: range(20, 81, 5),
    // heights in inches: 58 to 74 with step size 2
    heights: range(58, 79, 2),
    // spirometry values in ml
    spiro: [
      // 58,   60,   62,   64,   66,   68,   70,   72,   74,   76,   78 heights (in)
      [2350, 2500, 2700, 2900, 3050, 3250, 3400, 3550, 3750, 3900, 4100], // age 20
      [2300, 2500, 2650, 2850, 3000, 3200, 3350, 3550, 3700, 3900, 4050], // age 25
      [2300, 2450, 2600, 2800, 2950, 3150, 3300, 3500, 3650, 3850, 4000], // age 30
      [2250, 2400, 2600, 2750, 2950, 3100, 3300, 3450, 3650, 3800, 4000], // age 35
      [2200, 2350, 2550, 2700, 2900, 3050, 3250, 3400, 3600, 3750, 3950], // age 40
      [2150, 2350, 2500, 2700, 2850, 3050, 3200, 3350, 3550, 3700, 3900], // age 45
      [2100, 2300, 2450, 2650, 2800, 3000, 3150, 3350, 3500, 3700, 3850], // age 50
      [2100, 2250, 2400, 2600, 2750, 2950, 3100, 3300, 3450, 3650, 3800], // age 55
      [2050, 2200, 2400, 2550, 2750, 2900, 3100, 3250, 3450, 3600, 3800], // age 60
      [2000, 2150, 2350, 2500, 2700, 2850, 3050, 3200, 3400, 3550, 3750], // age 65
      [1950, 2150, 2300, 2500, 2650, 2850, 3000, 3150, 3350, 3500, 3700], // age 70
      [1900, 2100, 2250, 2450, 2600, 2800, 2950, 3150, 3300, 3500, 3650], // age 75
      [1900, 2050, 2200, 2400, 2550, 2750, 2900, 3100, 3250, 3450, 3600]  // age 80
    ]
  }
};

export default data;
